import Tooltip from '@material-ui/core/Tooltip'
import React from 'react'
import {
  Edit,
  FormDataConsumer,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectField,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin'
import { Field } from 'redux-form'
import CategoryFilterField from '../categories/CategoryFilterField'

const NameField = ({ record }) => {
  if (!record) {
    return <div>No data available</div>
  }

  return (
    <Tooltip
      disabled={record?.disabled}
      title={record?.description || 'No description available'}
      key={record.id}
      placement="bottom"
    >
      <div>{record.name || 'Unnamed Role'}</div>
    </Tooltip>
  )
}

const UserEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <SelectField
          disabled={true}
          source="loginType"
          choices={[
            {
              id: 'Username-Password-Authentication',
              name: 'Email & Password',
            },
            { id: 'google-oauth2', name: 'Google' },
            { id: 'microsoft', name: 'Microsoft' },
          ]}
          defaultValue="Username-Password-Authentication"
        />
        <TextField source="email" />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.loginType === 'Username-Password-Authentication' && (
              <div>
                <TextInput source="firstName" resettable {...rest} />
                <br />
                <TextInput source="familyName" resettable {...rest} />
              </div>
            )
          }
        </FormDataConsumer>
        <ReferenceArrayInput source="userRoles" reference="roles">
          <SelectArrayInput optionText={<NameField />} translateChoice={false} />
        </ReferenceArrayInput>
        <SelectInput
          source="language"
          choices={[
            { id: 'en', name: 'main.english' },
            { id: 'nl', name: 'main.dutch' },
            { id: 'fr', name: 'main.french' },
            { id: 'es', name: 'main.spanish' },
            { id: 'da', name: 'main.danish' },
            { id: 'it', name: 'main.italian' },
            { id: 'ro', name: 'main.romanian' },
            { id: 'no', name: 'main.norwegian' },
            { id: 'de', name: 'main.german' },
          ]}
          defaultValue={'en'}
        />
        <Field name="category" component={CategoryFilterField} />
      </SimpleForm>
    </Edit>
  )
}

export default UserEdit
